import {GenericList} from './GenericList';
import {Service} from '../../models/Service';

export class ServiceList extends GenericList<Service> {}
